export default function (router) {
    router.beforeEach((to, from, next) => {
        /**
         * If route does NOT have redirectIfAuthenticated middleware then keep going on.
         */
        if (!_.get(to, 'meta.middleware.redirectIfAuthenticated', false)) {
            return next()
        }

        if (router.app.$store.state.auth.authenticated) {
            next({ name: 'memberDashboard.classroom.overview' })
        } else {
            next()
        }
    })
}